package com.jingfangpai.common.orm.mapping

import kotlinx.serialization.Serializable

@Serializable
open class SignSymptomSettingRelievedBy(var id: String? = null){
	var signSymptomSettingId: String? = null
	var associatedFactorId: String? = null

	override fun equals(other: Any?): Boolean {
		if (this === other) return true
		if (other == null || this::class != other::class) return false
		other as SignSymptomSettingRelievedBy
		if (id != other.id) return false
		if (signSymptomSettingId != other.signSymptomSettingId) return false
		if (associatedFactorId != other.associatedFactorId) return false
		return true
	}

	override fun hashCode(): Int {
		var result = 0
		result = 31 * result + (id?.hashCode() ?: 0)
		result = 31 * result + (signSymptomSettingId?.hashCode() ?: 0)
		result = 31 * result + (associatedFactorId?.hashCode() ?: 0)
		return result
	}

}
